import { render } from "./billing_payment.vue?vue&type=template&id=319cf328"
import script from "./billing_payment.vue?vue&type=script&lang=js"
export * from "./billing_payment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__